import * as React from "react";
import usePermissions from "hooks/usePermissions";
import { Link } from "components/common";
import LicensesRoutes from "license/Routes";
const LicenseHelp = () => {
  const { isPermitted } = usePermissions();
  return isPermitted("licenses:create") ? /* @__PURE__ */ React.createElement("span", null, "Go to the ", /* @__PURE__ */ React.createElement(Link, { to: LicensesRoutes.LIST }, "Licenses page"), " for more information or contact your account manager.") : /* @__PURE__ */ React.createElement("span", null, "Contact your account manager for more information.");
};
export default LicenseHelp;
